<template>
  <div
    v-show="loaderEnabler"
    class="spinner"
  >
    <div class="spinner__content"/>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'VSpinner',
  computed: {
    ...mapState({
      loaderEnabler: (state) => state.loader,
    }),
  }
};
</script>

<style lang="scss" scoped>
.spinner {
  overflow: hidden;
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  z-index: 100;

  &__content {
    border-width: 10px;
    border-style: solid;
    border-color: #f3f3f3;
    border-top-color: var(--color-secondary);
    border-radius: 50%;
    width: 80px;
    height: 80px;
    animation: spin 2s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
